import React, { useState, useEffect } from 'react';
import { 
    IconButton, Chip, Box, TableRow, TableCell, Tooltip, Snackbar, Alert, Typography 
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import DataTable from '../DataTable';
import * as API from '../../api';
import HumanResourceDialog from './HumanResourceDialog';

const HumanResourceTab = ({ openAddSignal, onCloseAdd }) => {
    const [data, setData] = useState([]);
    const [editItem, setEditItem] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
    const userRole = localStorage.getItem('user_role') || 'SALE';

    const loadData = async () => {
        try {
            // Gọi API list human-resources
            const res = await API.client.get('/human-resources/');
            setData(res.data);
        } catch (e) { console.error(e); }
    };

    useEffect(() => { loadData(); }, []);

    useEffect(() => {
        if (openAddSignal) {
            setEditItem(null);
            setIsOpen(true);
        }
    }, [openAddSignal]);

    const columns = [
        { label: 'Họ và tên', field: 'full_name', minWidth: 180 },
        { label: 'Username', field: 'username', minWidth: 120 },
        { label: 'Vai trò', field: 'roles', minWidth: 150 },
        { label: 'Liên hệ', field: 'contact', minWidth: 200 },
        { label: 'Cổ phần (Lãi/Nợ)', field: 'shares', minWidth: 150, align: 'right' },
        { label: 'Thao tác', field: 'actions', minWidth: 80, align: 'center' },
    ];

    return (
        <Box>
            <DataTable
                columns={columns}
                data={data}
                renderRow={(row) => (
                    <TableRow key={row.id} hover>
                        <TableCell>
                            <Typography variant="body2" fontWeight="bold" color="#007373">
                                {row.full_name}
                            </Typography>
                        </TableCell>
                        <TableCell>{row.username}</TableCell>
                        <TableCell>
                            <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                {row.is_employee && (
                                    <Chip 
                                        icon={<PersonIcon style={{ fontSize: 16 }} />} 
                                        label={row.job_title || "Nhân viên"} 
                                        color="primary" size="small" variant="outlined" 
                                    />
                                )}
                                {row.is_shareholder && (
                                    <Chip 
                                        icon={<ShowChartIcon style={{ fontSize: 16 }} />} 
                                        label="Cổ đông" 
                                        color="secondary" size="small" variant="outlined" 
                                    />
                                )}
                            </Box>
                        </TableCell>
                        <TableCell>
                            {row.phone && <Typography variant="caption" display="block">📞 {row.phone}</Typography>}
                            {row.email && <Typography variant="caption" display="block">✉️ {row.email}</Typography>}
                        </TableCell>
                        <TableCell align="right">
                            {row.is_shareholder ? (
                                <Box>
                                    <Typography variant="caption" sx={{ color: 'green', fontWeight: 'bold' }}>Lãi: {row.profit_percentage}%</Typography>
                                    <br/>
                                    <Typography variant="caption" sx={{ color: 'orange', fontWeight: 'bold' }}>Nợ: {row.debt_percentage}%</Typography>
                                </Box>
                            ) : (
                                <Typography variant="caption" color="text.secondary">---</Typography>
                            )}
                        </TableCell>
                        <TableCell align="center">
                            <Tooltip title="Sửa thông tin">
                                <IconButton size="small" color="primary" onClick={() => { setEditItem(row); setIsOpen(true); }}>
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                )}
            />

            <HumanResourceDialog
                open={isOpen}
                onClose={() => { setIsOpen(false); onCloseAdd(); }}
                initialData={editItem}
                onSuccess={() => { setIsOpen(false); onCloseAdd(); loadData(); }}
            />

            <Snackbar 
                open={toast.open} 
                autoHideDuration={2000} 
                onClose={() => setToast({ ...toast, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity={toast.severity} variant="filled">{toast.message}</Alert>
            </Snackbar>
        </Box>
    );
};

export default HumanResourceTab;